import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
// import { Trash2 } from "lucide-react";
import Tooltip from "../../../../../../../../components/shared/Tooltip";
import Avatar from "../../../../../../../../components/shared/Avatar";
import { renderUserName } from "../../../../../../../../utils/helpers/user";

function Unavailable({ event, day }: any) {
    const { t } = useTranslation();

    return (
        <Tooltip
            side="right"
            triggerClassName="cursor-pointer border border-rose-400 rounded-md px-3 py-1 mb-1 text-sm text-rose-400"
            contentClassName="bg-white shadow-md p-3 rounded-md"
            trigger={`${event.data.length} ${t("unavailable")}`}
        >
            <div className="tw-text-neutral-900 tw-text-sm tw-font-medium tw-mb-2 tw-mx-3 tw-text-start">
                {t("unavailable-on", {
                    date: moment(day).format("dddd DD, MMM YYYY")
                })}
            </div>

            <div className="tw-flex tw-flex-col">
                {event.data.map((item: any) => {
                    return (
                        <div key={item.id} className="tw-flex gap-17 tw-justify-between tw-items-center align-center tw-bg-rose-50 tw-text-rose-500 tw-px-4 tw-py-2 tw-rounded-md tw-mb-1">
                            <div className="tw-flex tw-items-center">
                                <Avatar user={item?.user} />
                                <p className="tw-text-neutral-900 tw-font-semibold">{renderUserName(item?.user)}</p>
                            </div>
                            <p className="tw-text-rose-500 tw-font-bold tw-bg-rose-100 tw-px-3 tw-py-2 tw-rounded-lg">
                                {!item.allDay
                                    ? moment(item.startDate).format("hh:mma") + " - " + moment(item.endDate).format("hh:mma")
                                    : t("all-day")}
                            </p>
                        </div>
                    )
                })}
            </div>
        </Tooltip>
    );
}

export default Unavailable;
